module.exports = __webpack_public_path__ + "img/exambg.262a37eb.png";